<template>
    <div class="buyOrder">
         <div class="order-header flex align-cen">
      <div class="header-container-left" @click="openGo">
        <img
          src="../../../assets/images/HeroopSys.png"
          alt=""
          class="sider-logo"
        />
      </div>
      <div class="header-container-con"></div>
      <div class="header-container-right mft" style="margin-right: 24px">
        <el-dropdown>
          <span
            class="el-dropdown-link flex align-cen"
            style="color: #fff; cursor: pointer"
          >
           <img :src="user.avatar || require('../../../assets/images/head.png')" alt="" class="sider-logo">
           {{user.name}} 
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="openMan"><i class="icon-al-laptop"></i> 进入后台</el-dropdown-item>
            <el-dropdown-item @click.native="openSet"><i class="icon-al-cog"></i> 账号设置</el-dropdown-item>
            <el-dropdown-item  @click.native="openOrder"><i class="icon-al-file"></i> 订单管理</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 确认订单页 -->
    <div class="confirmBuy">
            <div class="public-tit">
            <div class="public-tit-list">
               确认订单
            </div>
        </div>
        <div class="confirmBuy-order-info">
            <div class="info-head">
               <h3> 订单信息</h3>
            </div>
            <div class="info-wrap" v-if="list && list.appSku">
                <div class="info-list flex align-cen">
                <div class="label">订购服务</div>
                 <div class="info-con mft">{{ list.appSku.name }}</div>
                </div>
                 <div class="info-list flex align-cen">
                <div class="label">订单主体</div>
                 <div class="info-con mft">{{ list.business.name }}</div>
                </div>
                <div class="info-list flex align-cen">
                <div class="label">账号个数</div>
                 <div class="info-con mft">{{ list.appSku.accountNum || '无限制' }}</div>
                </div>
                <div class="info-list flex align-cen">
                <div class="label">使用期限(月)</div>
                 <div class="info-con mft">{{ list.appSku.deadline || '无限制' }}</div>
                </div>
                  <div class="info-list flex align-cen">
                <div class="label">折扣金额</div>
                 <div class="info-con mft">¥{{ list.discountAmount || '0' }}</div>
                </div>
                 <div class="info-list  info-price flex align-cen">
            <div class="info-con mft">
              <span style="margin-right:20px">订单金额</span> <span class="mft-price" style="color:#ea3a3a"> ¥{{list.payAmount}}</span>
            </div>
          </div>
            </div>
               <div class="info-wrap" v-if="list && list.courseSku">
                <div class="info-list flex align-cen">
                <div class="label">订购服务</div>
                 <div class="info-con mft">{{ list.courseSku.name }}</div>
                </div>
                 <div class="info-list flex align-cen">
                <div class="label">订单主体</div>
                 <div class="info-con mft">{{ list.business.name }}</div>
                </div>
                <div class="info-list flex align-cen">
                <div class="label">账号个数</div>
                 <div class="info-con mft">{{ list.courseSku.accountNum || '无限制' }}</div>
                </div>
                <div class="info-list flex align-cen">
                <div class="label">使用期限(月)</div>
                 <div class="info-con mft">{{ list.courseSku.deadline || '无限制' }}</div>
                </div>
                  <div class="info-list flex align-cen">
                <div class="label">折扣金额</div>
                 <div class="info-con mft">¥{{ list.discountAmount || '0' }}</div>
                </div>
                 <div class="info-list  info-price flex align-cen">
            <div class="info-con mft">
              <span style="margin-right:20px">订单金额</span> <span class="mft-price" style="color:#ea3a3a"> ¥{{list.payAmount}}</span>
            </div>
          </div>
            </div>
        </div>
        <div class="confirmBuy-order-type">
              <div class="info-head">
               <h3> 支付方式</h3>
            </div>
            <div class="payment-list flex align-cen">
                <div class="pay-type wechat flex align-cen" @click="payMent('wechat')"> 
                    <img src="../../../assets/images/wechat.png" alt="">
                    <span>微信</span>
                    <b></b>
                     </div>
                <div class="pay-type airAplay flex align-cen" @click="payMent('airpay')" v-if="!$util.isWeixinBrowser()">
                    <img src="../../../assets/images/airplay.png" alt="">
                    <span>支付宝</span>
                    <b></b>
                    </div>
                      <el-tooltip class="item" effect="dark" content="到账后2个工作日开通" placement="top">
                <div class="pay-type duigong flex align-cen"
                @click="$util.Notifi('对公转账暂不可用','error','fa-exclamation-circle')"
                >
                    <img src="../../../assets/images/duigong.png" alt="">
                    <span>对公转账</span>
                    <b></b>
                </div>
                </el-tooltip>
            </div>
          <!-- <div class="helpios" v-if="isIOS && this.$util.isMobile()">注意：支付宝支付时如果遇到系统繁忙，请复制链接重新打开支付（因苹果底层协议限制，需要重新打开，不需要更换浏览器）<span @click="copyPay">复制</span></div> -->
        </div>
    </div>
        <el-dialog
  title="微信支付"
  :visible.sync="centerDialogVisible"
  width="400px"
  :append-to-body="true"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  center
  v-if="centerDialogVisible"
  >
          <div class="imgcode">
            <!-- <img :src="weChatCodeImg" alt=""> -->
            <el-image  :src="weChatCodeImg">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <p>请使用微信扫一扫支付</p>
        <div class="maskSuccess" v-if="paySuccess">
            <i class="el-icon-loading"></i>  支付成功
        </div>
          </div>
        </el-dialog>
        <div v-html="aiphtml"></div>
    </div>
</template>
<script>
import LocaStorage from "../../../utils/localstorage.js";
import { airPay, weChat, orderDetail,weChatPayQuery,airPayQuery,enBusiness} from "@/api/enterprise/index"; // 支付宝支付、微信支付、订单详情、查询微信支付交易、查询支付宝交易
export default {
    inject: ["reload"],
    name:'buyOrder',
    data() {
        return {
          aiphtml:'',
          centerDialogVisible:false,
            user:{},
            list:{},
            htmlstr:'',
            weChatCodeImg:'',
            timer:null,
            paySuccess:false,
            isIOS:false,
        }
    },
      created() {
    const token1 = LocaStorage.setAge().get("token1");
    const userinfo1 = LocaStorage.setAge().get("userinfo1");
    this.user = userinfo1;
    document.title = '产品购买'
    let u = navigator.userAgent;
    this. isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
     this.getInfo()
  },
     mounted() {
    this.$bus.$emit("isShow", false);
  },
  methods: {
    // 复制链接
    copyPay(){
        let str = this.$config.prUrl + '#/webenterpriseHlrj/buyOrder?id=' + this.$route.query.id 
              let _self = this
                this.$copyText(str).then(
                    function(e) {
                      _self.$util.Notifi('复制成功','success','fa-check')
                    },
                    function(e) {
                    _self.$util.Notifi('复制失败','error','fa-exclamation-circle'); 
                    }
                );
    },
      // 打开后台
        openMan(){
               // return this.$util.Notifi('加急开发中～','error','fa-exclamation-circle');
             enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                  localStorage.removeItem('businessInfo')
                 LocaStorage.setAge().set('businessInfo',res.data[0])
                const newurl = this.$router.resolve({path:'/webenterpriseManage/index', query: {}})
                 window.open(newurl.href,'_blank')
                }else{               
                 const newurl = this.$router.resolve({name:'HlrjenBusiness', query: {}})
                 window.open(newurl.href,'_blank')
                }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
        },
     // 打开设置
        openSet(){
            const newurl = this.$router.resolve({name:'enHLyhSetting', query: {}})
                 window.open(newurl.href,'_blank')
        },
    // 订单详情
    getInfo(){
        orderDetail({id:this.$route.query.id},'enterprise')
        .then(res =>{
            this.list = res.data
        })
        .catch(err =>{})
    },
    // 支付
      async payMent(type){
      if(this.$util.isMobile()){
        // 手机支付
        if(type == "wechat"){
          this.$util.Notifi('微信支付暂不可用','error','fa-exclamation-circle')
        }else if(type == "airpay"){
          if(this.$util.isWeixinBrowser()) return   this.$util.Notifi('点击右上角使用浏览器支付！','error','fa-exclamation-circle')
          if(this.isIOS){
                 let str = this.$config.prUrl + '#/webenterprise/viewpay?id=' + this.$route.query.id
                this.$confirm('因苹果底层协议限制，请复制链接打开支付（不需要更换浏览器）, 是否继续?', '支付宝支付', {
                            confirmButtonText: '复制',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(() => {
                             let _self = this
                this.$copyText(str).then(
                    function(e) {
                      _self.$util.Notifi('复制成功','success','fa-check')
                    },
                    function(e) {
                    _self.$util.Notifi('复制失败','error','fa-exclamation-circle'); 
                    }
                );
                          })
          }else{
          airPay({id:this.list.id,type:'mobile'},'enterprise')
            .then(res =>{
                this.aiphtml = res.data
              this.$nextTick(() => 
             document.forms[0].submit()
            )
            })
            .catch(err =>{this.$util.Notifi(err.msg,'error','fa-exclamation-circle')})
          }
        }
      }else{
                if(type == "wechat"){
            weChat({id:this.list.id},'enterprise')
            .then(res =>{
              if(res.code == 0){
                this.centerDialogVisible = true
              this.weChatCodeImg = res.data.imgPath
              this.timer = setInterval(() => {
                setTimeout(this.getWeChatPayQuery(),0)
              }, 5000);
              }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
              }
            })
            .catch(err =>{this.$util.Notifi(err.msg,'error','fa-exclamation-circle')})
        }else if(type == "airpay"){
            const newTab = window.open();
            airPay({id:this.list.id,type:''},'enterprise')
            .then(res =>{
               const div = document.createElement('div');
                div.innerHTML = res.data; // html code
                newTab.document.body.appendChild(div);
                newTab.document.forms.punchout_form.submit();       
                this.$confirm('请选择支付结果?', '提示', {
                        confirmButtonText: '支付成功',
                        cancelButtonText: '支付失败',
                        type: 'warning'
                      }).then(() => {
                        this.$bus.$emit("isShow", true);
                      this.getAliPayQuery()
                      }).catch(() => {     
                        this.$router.push({
                          name:'HlrjorderAdmin',
                          query: {
                          id:this.list.appId,
                          businessId:this.list.businessId
                          }
                      })    
                      });  
            })
            .catch(err =>{this.$util.Notifi(err.msg,'error','fa-exclamation-circle')})
        }
      }
    },
    // 查询支付宝交易订单
    getAliPayQuery(){
        airPayQuery({id:this.list.id},'enterprise')
        .then(res =>{
            if(res.code == 0){
              let redirectName
              this.$route.query.redirect ? redirectName = this.$route.query.redirect : redirectName = 'endowloadHlyhDetail'
            this.$router.push({
                    name: redirectName,
                    query: {
                    id: this.list.appId,
                    type: "2",
                    },
                });
            }else{
            this.$util.Notifi('支付未成功','error','fa-exclamation-circle');
            this.$router.push({
                    name:'HlrjorderAdmin',
                    query: {
                    id:this.list.appId,
                     businessId:this.list.businessId
                    }
                }) 
            }
        })
         .catch(err =>{})
    },
    // 查询微信交易订单
      getWeChatPayQuery(){
        weChatPayQuery({id:this.list.id},'enterprise')
        .then(res =>{
            if(res.code == 0){
            this.paySuccess = true
            if(res.data.orderStatus == 2){
             this.$util.Notifi('支付成功','success','fa-check');
            this.$bus.$emit("isShow", true);
             clearInterval(this.timer)
             let redirectName
              this.$route.query.redirect ? redirectName = this.$route.query.redirect : redirectName = 'endowloadHlyhDetail'
                            setTimeout(() => {
                              this.$router.push({
                                  name: redirectName,
                                  query: {
                                    id: this.list.appId,
                                    type: "2",
                                  },
                                });
                        this.paySuccess = false 
					},300);
            }else{
                 this.$util.Notifi('支付失败','error','fa-exclamation-circle');
                  clearInterval(this.timer)
                  this.paySuccess = false 
            }
            }
         if(!this.centerDialogVisible) clearInterval(this.timer)
        })
        .catch(err =>{})
      },
      // 打开订单管理
        openOrder(){
            this.$router.push({
                name:'HlrjorderAdmin',
                 query: {
                 id:this.list.appId,
                 businessId:this.list.businessId
                }
            })
        },
      // 返回上一层
    openGo() {
         this.$bus.$emit("isShow", true);
      this.$router.push('/webenterpriseHlrj/homePage');
    },
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>
.helpios{
  font-size: 14px;
  color: red;
  span{
    padding: 2px 0px;
    background: #155bd4;
    color: #fff;
    border-radius: 3px;
    display: block;
    margin-top: 10px;
    width: 100px;
    text-align: center;
  
  }
}
.buyOrder{
         background: #f0f1f4;
         height: 100vh;
      .order-header {
    position: relative;
    background: #fff;
    height: 64px;
    position: relative;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    .header-container-left {
      line-height: 64px;
      height: 64px;
      margin-left: 24px;
      margin-right: 24px;
      img {
        width: 80px;
      }
    }
    .header-container-right {
      img {
        width: 30px;
        margin-right: 10px;
        height: 30px;
        border-radius: 50%;
      }
      .right-btn {
        height: 64px;
        margin-left: 24px;
        margin-right: 24px;
        color: #333;
        .right-login {
          margin-right: 24px;
          cursor: pointer;
        }
        .trial {
          padding: 10px 24px;

          color: #333;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .confirmBuy{
    max-width: 900px;
    margin: 50px auto;
     box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
     background: #fff;
     border-radius: 5px;
     .public-tit{
        border-radius: 5px 5px 0 0;
        border: none;
        background: #155bd4;
        color: #fff;
        text-align: center;
     }
     .confirmBuy-order-info{
        padding: 20px;
        .info-wrap{
            width: 400px;
            margin: 0 auto;
            background: #f5f5f5;
             box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
            padding: 10px 0px;
            border-radius: 5px;
            color: #666;
            padding-bottom: 0;
            .info-list{
                margin-top: 10px;
                padding: 0 20px;
            }
            .info-price{
                background: #fff;
                padding: 20px;
            }
            .label {
          color: #999;
          font-size: 12px;
        }
        }
     }
     .confirmBuy-order-type{
        padding: 20px;
        border-top: 1px solid #ddd;
        .payment-list{
            padding: 20px;
            .pay-type {
                border: 1px solid #ddd;
                height: 32px;
                line-height: 32px;
                padding: 5px 24px;
                cursor: pointer;
                margin-right: 10px;
                border-radius: 5px;
                position: relative;
                img{
                    width: 16px;
                    padding-right: 5px;
                }
                b{
                    display: none;;
                    position: absolute;
                    width: 12px;
                    height: 12px;
                    right: 0;
                    bottom: 0;
                    overflow: hidden;
                    background: url('../../../assets/images/selected-icon.png') no-repeat 0 0;
                }
            }
            .pay-type:hover{
                border: 2px solid #e4393c;
                 padding: 4px 22px;
                 b{
                    display: block;
                 }
               
            }
        }
     }
  }
}
::v-deep {
  .el-dropdown-link {
    color: #333 !important;
  }
  .el-image{
    width: 100%;
  }
  .imgcode{
          p{
            text-align: center;
            padding-top: 10px;
          }
          img{
            width: 300px;
            height: 300px;
            display: block;
            margin: 0 auto;
          }
          .maskSuccess{
            background: rgba(255,255,255,0.8);
            width: 250px;
            height: 250px;
            position: absolute;
            top: 105px;
            left: 75px;
            color: #333;
            text-align: center;
            line-height: 250px;
            font-weight: bold;
            i{color: #333;font-weight: bold;}
          }
        }
}
@media (max-width: 640px){
  .buyOrder{
    margin-top: -56px;
    position: relative;
    overflow-x: hidden;
    .confirmBuy{
      width: 90%;
      margin: 0 auto;
      margin-top: 20px;
      .info-wrap{
        width: 100% !important;
      }
      .payment-list{display: block;}
      .pay-type{
        width: 150px !important;
        margin: 0 auto !important;
        margin-bottom: 20px !important;
        justify-content: center;
      }
    }
  }
}
</style>